import {
  CategoryStandardProduct,
  CategoryStandardProductDeliveryMethod,
} from "shared/api/middleware-api-client";

export const useStandardProductsDeliveryMethod = () => {
  const calculateDeliveryMethod = (
    standardProducts: CategoryStandardProduct[]
  ) => {
    return standardProducts.reduce(
      (
        prevDeliveryMethod: CategoryStandardProductDeliveryMethod | undefined,
        product
      ) => {
        if (
          !prevDeliveryMethod ||
          product.deliveryMethod.prio < prevDeliveryMethod.prio
        )
          return product.deliveryMethod;
        return prevDeliveryMethod;
      },
      undefined
    );
  };
  return { calculateDeliveryMethod };
};
